import React, { useContext } from 'react';
import { SNavbar, SNavbarList, SNavbarListItem } from './styled/SNavbar';
import { Flex, Box } from '@rebass/grid';
import { NavLink, Link } from 'react-router-dom';
import Button from '../button/Button';
import { AuthenticationContext } from '../../providers/AuthenticationProvider';

interface NavbarItemProps {
    title: string;
    link?: string;
    isAction?: boolean;
    protected?: boolean;
    id?: string;
}
interface NavbarProps {
    items: NavbarItemProps[];
    logo: string;
}

function capitalize(text: string) {
    return text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
}

function getNavList(navbarItems: NavbarItemProps[], authenticated: boolean, isAdmin: boolean, isAutoLogin: boolean, logOut: () => void) {

    const protectedItems: NavbarItemProps[] = navbarItems.filter((item) => item.protected);
    const publicItems: NavbarItemProps[] = navbarItems.filter((item) => !item.protected);
    let itemsToShow = authenticated ? protectedItems : publicItems;
    if (!isAdmin) {
        itemsToShow = itemsToShow.filter(item => item.id !== 'users');
    }
    if (isAutoLogin) {
        itemsToShow = itemsToShow.filter(item => item.id !== 'profile');
    }
    return <SNavbarList>
        { itemsToShow.map((item, index) => {
            if (item.isAction && !isAutoLogin) {
                return <SNavbarListItem key={index}><Button id={`navbar-${item.id}-button`} kind={'secondary'} small={true} key={index} onClick={logOut}>{item.title}</Button></SNavbarListItem>;
            } else if(item.link) {
                return <SNavbarListItem key={index}><NavLink id={`navbar-${item.id}-link`} activeClassName='active' to={item.link}>{capitalize(item.title)}</NavLink></SNavbarListItem>;
            }
            return null;
        })}
    </SNavbarList>
}

function Navbar(props: NavbarProps) {

    const { authenticated, logOut, isAdmin, isAutoLogin } = useContext(AuthenticationContext);

    return (<SNavbar id={'header'}>
        <Flex width='100%' justifyContent='space-between' alignItems='center'>
            <Link to="/" id={'header-logo'}><img width="155" height="31" src={`/images/${props.logo}`} alt='logo' /></Link>
            <Box id={'header-navbar'}>
                { getNavList(props.items, authenticated, isAdmin, isAutoLogin, logOut)}
            </Box>
        </Flex>
    </SNavbar>);
}

export default Navbar;
